export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "Home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["トップページ"])},
      "My page": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["マイアカウント"])}
    }
  })
}
